// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .pipe-selection {
  position: absolute;
  top: 35px;
  bottom: 0px;
  overflow: auto;
  width: calc(100% - 10px);
  padding-top: 5px;
}
:host .pipe-selection .style-size {
  width: 80px;
  text-align: left;
}
:host ::ng-deep .mat-tab-label {
  height: 34px !important;
  min-width: 110px !important;
  width: 110px !important;
}
:host .toolbox {
  float: right;
  margin-bottom: 3px;
}
:host .toolbox button {
  margin-right: 8px;
  margin-left: 8px;
}
:host .action-readonly-item {
  display: block;
  /* min-height: 100px; */
  width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 5px 0px 5px 0px;
}
:host .action-readonly-item .tag {
  width: calc(100% - 5px);
}
:host .action-readonly-item .tag input {
  width: inherit;
}
:host .action-readonly-item .value {
  width: calc(100% - 5px);
}
:host .action-readonly-item .value .number > input {
  width: 50px;
}
:host .action-readonly-item .value .type > input {
  width: auto;
}
:host .image-animation mat-select, :host .image-animation span {
  width: calc(100% - 10px);
}
:host .image-animation img {
  max-width: 200px;
}
:host .image-animation button {
  float: right;
}`, "",{"version":3,"sources":["webpack://./src/app/gauges/controls/pipe/pipe-property/pipe-property.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/gauges/controls/pipe/pipe-property/pipe-property.component.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,wBAAA;EACA,gBAAA;ACAR;ADEQ;EACI,WAAA;EACA,gBAAA;ACAZ;ADII;EACI,uBAAA;EACA,2BAAA;EACA,uBAAA;ACFR;ADKI;EACI,YAAA;EAEA,kBAAA;ACJR;ADOI;EACI,iBAAA;EACA,gBAAA;ACLR;ADQI;EACI,cAAA;EACA,uBAAA;EACA,WAAA;EACA,2CAAA;EACA,wBAAA;ACNR;ADSQ;EACI,uBAAA;ACPZ;ADQY;EACI,cAAA;ACNhB;ADSQ;EACI,uBAAA;ACPZ;ADSY;EACI,WAAA;ACPhB;ADSY;EACI,WAAA;ACPhB;ADaQ;EACI,wBAAA;ACXZ;ADcQ;EACI,gBAAA;ACZZ;ADcQ;EACI,YAAA;ACZZ","sourcesContent":[":host {\n    .pipe-selection {\n        position: absolute;\n        top: 35px;\n        bottom: 0px;\n        overflow: auto;\n        width:calc(100% - 10px);\n        padding-top: 5px;\n\n        .style-size {\n            width: 80px;\n            text-align: left;\n        }\n    }\n\n    ::ng-deep .mat-tab-label {\n        height: 34px !important;\n        min-width: 110px !important;\n        width: 110px !important;\n    }\n\n    .toolbox {\n        float: right;\n        // margin-top: 5px;\n        margin-bottom: 3px;\n    }\n\n    .toolbox button {\n        margin-right: 8px;\n        margin-left: 8px;\n    }\n\n    .action-readonly-item {\n        display: block;\n        /* min-height: 100px; */\n        width: 100%;\n        border-bottom: 1px solid rgba(0,0,0,0.1);\n        padding: 5px 0px 5px 0px;\n\n\n        .tag {\n            width: calc(100% - 5px);\n            input {\n                width: inherit;\n            }\n        }\n        .value {\n            width: calc(100% - 5px);\n\n            .number > input {\n                width: 50px;\n            }\n            .type > input {\n                width: auto;\n            }\n        }\n    }\n\n    .image-animation {\n        mat-select, span {\n            width: calc(100% - 10px);\n        }\n\n        img {\n            max-width: 200px;\n        }\n        button {\n            float: right;\n        }\n    }\n}\n",":host .pipe-selection {\n  position: absolute;\n  top: 35px;\n  bottom: 0px;\n  overflow: auto;\n  width: calc(100% - 10px);\n  padding-top: 5px;\n}\n:host .pipe-selection .style-size {\n  width: 80px;\n  text-align: left;\n}\n:host ::ng-deep .mat-tab-label {\n  height: 34px !important;\n  min-width: 110px !important;\n  width: 110px !important;\n}\n:host .toolbox {\n  float: right;\n  margin-bottom: 3px;\n}\n:host .toolbox button {\n  margin-right: 8px;\n  margin-left: 8px;\n}\n:host .action-readonly-item {\n  display: block;\n  /* min-height: 100px; */\n  width: 100%;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  padding: 5px 0px 5px 0px;\n}\n:host .action-readonly-item .tag {\n  width: calc(100% - 5px);\n}\n:host .action-readonly-item .tag input {\n  width: inherit;\n}\n:host .action-readonly-item .value {\n  width: calc(100% - 5px);\n}\n:host .action-readonly-item .value .number > input {\n  width: 50px;\n}\n:host .action-readonly-item .value .type > input {\n  width: auto;\n}\n:host .image-animation mat-select, :host .image-animation span {\n  width: calc(100% - 10px);\n}\n:host .image-animation img {\n  max-width: 200px;\n}\n:host .image-animation button {\n  float: right;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
